

import React from 'react';
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/dist/styles.css';

const AutoplaySlider = withAutoplay(AwesomeSlider);

const banners = [
    'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740466699884_rewardsHomeBanner',
    'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740466699884_rewardsHomeBanner'
];

function Header() {
    return (
        <div className="w-full flex flex-col lg:flex-row gap-6 mb-4">
            {/* Banner Slider */}
            <AutoplaySlider
                bullets={false}
                play={true}
                cancelOnInteraction={false}
                interval={3000}
                organicArrows={false}
                className="hidden lg:block lg:w-[72%] xl:w-[75%] h-[250px] rounded-lg" // Apply border-radius
                style={{
                    backgroundColor: 'transparent',
                    borderRadius: '12px',
                    overflow: 'hidden'
                }} 
            >
                {banners.map((banner, index) => (
                    <div key={index} className="w-full h-full">
                        <img
                            src={banner}
                            className="w-full h-full object-cover rounded-lg" // Apply border-radius to images
                            alt={`banner-${index}`}
                        />
                    </div>
                ))}
            </AutoplaySlider>

            <img
                src="https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1740466751613_rewardsCardHome"
                className="w-full lg:w-[25%] h-[220px] lg:h-[250px]"
                alt="card"
            />
        </div>
    );
}

export default Header;
